import React, { useState } from 'react';

const Investment = () => {
  const [certificateNo, setCertificateNo] = useState('');
  const [mobile, setMobile] = useState('');
  const [type, setType] = useState('');
  const [investmentDetails, setInvestmentDetails] = useState([]);

  // Mock data for investments (this would usually come from an API)
  const mockInvestmentData = [
    { certificateNo: 'INV12345', mobile: '9876543210', type: 'Stocks', amount: 5000, date: '2024-01-15' },
    { certificateNo: 'INV12346', mobile: '1234567890', type: 'Bonds', amount: 3000, date: '2023-12-05' },
    { certificateNo: 'INV12347', mobile: '5551234567', type: 'Mutual Funds', amount: 2000, date: '2024-02-10' },
    { certificateNo: 'INV12348', mobile: '6667890123', type: 'Stocks', amount: 7000, date: '2023-11-20' },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();

    // Filter data based on search parameters
    const filteredData = mockInvestmentData.filter((investment) => {
      const isCertificateMatch = certificateNo ? investment.certificateNo.includes(certificateNo) : true;
      const isMobileMatch = mobile ? investment.mobile.includes(mobile) : true;
      const isTypeMatch = type ? investment.type === type : true;
      
      return isCertificateMatch && isMobileMatch && isTypeMatch;
    });

    setInvestmentDetails(filteredData);
  };

  const containerStyle = {
    marginTop: '50px',
    padding: '20px',
    backgroundColor: '#f4f4f9',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '1200px',
    marginLeft: 'auto',
    marginRight: 'auto',
  };

  const formGroupStyle = {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '15px',
    flex: 1,
    width: '30%',
  };

  const labelStyle = {
    fontWeight: 'bold',
    marginBottom: '5px',
  };

  const inputStyle = {
    padding: '8px',
    fontSize: '14px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    width: '100%',
  };

  const buttonStyle = {
    padding: '10px 20px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '16px',
    marginTop: '20px',
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '30px',
    tableLayout: 'auto',
  };

  const thTdStyle = {
    border: '1px solid #ddd',
    padding: '8px',
    textAlign: 'left',
  };

  const thStyle = {
    backgroundColor: '#f1f1f1',
    fontWeight: 'bold',
  };

  return (
    <div style={containerStyle}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Investment Details</h2>

      {/* Investment Form */}
      <form onSubmit={handleSubmit}>
        <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
          {/* Certificate No */}
          <div style={formGroupStyle}>
            <label style={labelStyle}>Search Certificate No</label>
            <input 
              type="text" 
              style={inputStyle} 
              value={certificateNo} 
              onChange={(e) => setCertificateNo(e.target.value)} 
              placeholder="Enter Certificate No" 
            />
          </div>

          {/* Mobile */}
          <div style={formGroupStyle}>
            <label style={labelStyle}>Search Mobile</label>
            <input 
              type="text" 
              style={inputStyle} 
              value={mobile} 
              onChange={(e) => setMobile(e.target.value)} 
              placeholder="Enter Mobile" 
            />
          </div>

          {/* Type */}
          <div style={formGroupStyle}>
            <label style={labelStyle}>Type</label>
            <select style={inputStyle} value={type} onChange={(e) => setType(e.target.value)}>
              <option value="">Select Type</option>
              <option value="Stocks">Stocks</option>
              <option value="Bonds">Bonds</option>
              <option value="Mutual Funds">Mutual Funds</option>
            </select>
          </div>

          <button type="submit" style={buttonStyle}>
            Submit
          </button>
        </div>
      </form>

      {/* Investment Table */}
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={{ ...thTdStyle, ...thStyle }}>Certificate No</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Mobile</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Type</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Amount</th>
            <th style={{ ...thTdStyle, ...thStyle }}>Date</th>
          </tr>
        </thead>
        <tbody>
          {investmentDetails.length === 0 ? (
            <tr>
              <td colSpan="5" style={thTdStyle}>No investments found</td>
            </tr>
          ) : (
            investmentDetails.map((investment, index) => (
              <tr key={index}>
                <td style={thTdStyle}>{investment.certificateNo}</td>
                <td style={thTdStyle}>{investment.mobile}</td>
                <td style={thTdStyle}>{investment.type}</td>
                <td style={thTdStyle}>{investment.amount}</td>
                <td style={thTdStyle}>{investment.date}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Investment;
